<div class="applicant-info-container">
  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Applicant</mat-label>
        <input matInput #applicantInput [(ngModel)]="applicant" class="applicant-info applicant-info-item-input" disabled />
      </mat-form-field>
    </div>
  </div>
  <div class="applicant-info-info applicant-info-info-text">
    Name of firm, sponsor or legal representative.
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Address</mat-label>
        <input matInput #street1Input [(ngModel)]="street1" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updateStreet1($event)" (keyup.escape)="cancelStreet1Update()" (blur)="updateStreet1($event)" />
        <mat-icon matSuffix (mousedown)="clearStreet1InputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('street1')">
      This is a required field.
    </div>
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Address 2 (Optional)</mat-label>
        <input matInput #street2Input [(ngModel)]="street2" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updateStreet2($event)" (keyup.escape)="cancelStreet2Update()" (blur)="updateStreet2($event)" />
        <mat-icon matSuffix (mousedown)="clearStreet2InputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field class="applicant-info-form-field">
        <mat-label>Country</mat-label>
          <mat-select [(value)]="country" (selectionChange)="updateCountry($event)">
            <ng-container  *ngFor="let c of countries">
              <mat-option [value]="c.key" class="applicant-info-select-item">{{ c.value }}</mat-option>
            </ng-container>
          </mat-select>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('country')">
      This is a required field.
    </div>
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>City</mat-label>
        <input matInput #cityInput [(ngModel)]="city" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updateCity($event)" (keyup.escape)="cancelCityUpdate()" (blur)="updateCity($event)" />
        <mat-icon matSuffix (mousedown)="clearCityInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('city')">
      This is a required field.
    </div>
  </div>

  <div [ngClass]="{'applicant-info-multi-item-row' : !isMobileDeviceSize}">
    <div class="applicant-info-item-container">
      <div class="applicant-info-item-input-container">
        <ng-container *ngIf="isCountryUSA;else outsideUSA">
          <mat-form-field class="applicant-info-form-field">
            <mat-label>State</mat-label>
            <mat-select [(value)]="state" (selectionChange)="updateState($event)">
              <ng-container  *ngFor="let s of states">
                <mat-option [value]="s.key" class="applicant-info-select-item">{{ s.value }}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-template #outsideUSA>
          <mat-form-field appearance="outline" class="applicant-info-form-field">
            <mat-label>State</mat-label>
            <input matInput #stateInput [(ngModel)]="state" class="applicant-info applicant-info-item-input"
              (keyup.enter)="updateState($event)" (keyup.escape)="cancelStateUpdate()" (blur)="updateState($event)" />
            <mat-icon matSuffix (mousedown)="clearStateInputField()">cancel</mat-icon>
          </mat-form-field>
        </ng-template>
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('state')">
        This is a required field.
      </div>
    </div>
 
    <div class="applicant-info-item-container">
      <div class="applicant-info-item-input-container">
        <mat-form-field appearance="outline" class="applicant-info-form-field">
          <mat-label>Zip Code</mat-label>
          <input matInput #postalCodeInput [(ngModel)]="postalCode" class="applicant-info applicant-info-item-input"
            (keyup.enter)="updatePostalCode($event)" (keyup.escape)="cancelPostalCodeUpdate()" (blur)="updatePostalCode($event)" />
          <mat-icon matSuffix (mousedown)="clearPostalCodeInputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('postalCode', 'required')">
        This is a required field.
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('postalCode', 'pattern')">
        Please enter a valid postal code.
      </div>
    </div>
  </div>

  <div [ngClass]="{'applicant-info-multi-item-row' : !isMobileDeviceSize}">
    <div class="applicant-info-item-container">
      <div class="applicant-info-item-input-container">
        <mat-form-field appearance="outline" class="applicant-info-form-field">
          <mat-label>Telephone number</mat-label>
          <input matInput #telephoneNumberInput [(ngModel)]="telephoneNumber" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updateTelephoneNumber($event)" (keyup.escape)="cancelTelephoneNumberUpdate()" (blur)="updateTelephoneNumber($event)" />
          <mat-icon matSuffix (mousedown)="clearTelephoneNumberInputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('telephoneNumber', 'required')">
        This is a required field.
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('telephoneNumber', 'pattern')">
        A valid phone number is required.
      </div>
    </div>

    <div class="applicant-info-item-container">
      <div class="applicant-info-item-input-container">
        <mat-form-field class="applicant-info-form-field">
          <mat-label>Telephone Type</mat-label>
            <mat-select [(value)]="telephoneType" (selectionChange)="updateTelephoneType($event)">
              <ng-container  *ngFor="let s of phoneTypes">
                <mat-option [value]="s.key" class="applicant-info-select-item">{{ s.value }}</mat-option>
              </ng-container>
            </mat-select>
        </mat-form-field>
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('telephoneType')">
        This is a required field.
      </div>
    </div>
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>First Name of contact person</mat-label>
        <input matInput #primaryContactFirstNameInput [(ngModel)]="primaryContactFirstName" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updatePrimaryContactFirstName($event)" (keyup.escape)="cancelPrimaryContactFirstNameUpdate()" (blur)="updatePrimaryContactFirstName($event)" />
        <mat-icon matSuffix (mousedown)="clearPrimaryContactFirstNameInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('primaryContactFirstName')">
      This is a required field.
    </div>
  </div>
  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Last Name of contact person</mat-label>
        <input matInput #primaryContactLastNameInput [(ngModel)]="primaryContactLastName" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updatePrimaryContactLastName($event)" (keyup.escape)="cancelPrimaryContactLastNameUpdate()" (blur)="updatePrimaryContactLastName($event)" />
        <mat-icon matSuffix (mousedown)="clearPrimaryContactLastNameInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('primaryContactLastName')">
      This is a required field.
    </div>
  </div>
  <div class="applicant-info-info applicant-info-info-text">
    If different from USAN applicant.
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Preferred Pronoun(s)</mat-label>
        <input matInput #pronounsInput [(ngModel)]="pronouns" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updatePronouns($event)" (keyup.escape)="cancelPronounsUpdate()" (blur)="updatePronouns($event)" />
        <mat-icon matSuffix (mousedown)="clearPronounsInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Title</mat-label>
        <input matInput #titleInput [(ngModel)]="title" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updateTitle($event)" (keyup.escape)="cancelTitleUpdate()" (blur)="updateTitle($event)" />
        <mat-icon matSuffix (mousedown)="clearTitleInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="applicant-info-item-container">
    <div class="applicant-info-item-input-container">
      <mat-form-field appearance="outline" class="applicant-info-form-field">
        <mat-label>Email address</mat-label>
        <input matInput #emailAddressInput [(ngModel)]="emailAddress" class="applicant-info applicant-info-item-input"
          (keyup.enter)="updateEmailAddress($event)" (keyup.escape)="cancelEmailAddressUpdate()" (blur)="updateEmailAddress($event)" />
        <mat-icon matSuffix (mousedown)="clearEmailAddressInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('emailAddress', 'required')">
      This is a required field.
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('emailAddress', 'email')">
      Please enter a valid email address.
    </div>
  </div>
</div>